<template>
  <div class="section ">
    <div
      slot="operations"
      class="triggers"
      style="padding-bottom: 10px"
    >
      <template v-if="action !== 'view'">
        <el-button
          type="primary"
          plain
          @click="cancel"
        >{{ $t('SystemMaintenance.Cancel') }}
        </el-button>
        <el-button
          type="primary"
          @click="toSave"
        >{{ $t('SystemMaintenance.Save') }}
        </el-button>
      </template>
      <template v-else>
        <el-button
          type="primary"
          @click="back"
        >{{ $t('SystemMaintenance.Return') }}
        </el-button>
        <el-button
          type="primary"
          :disabled="form.status !== '0'"
          @click="toEdit"
        >{{ $t('SystemMaintenance.Edit') }}
        </el-button>
        <el-button
          v-show="form.status === '0'"
          type="primary"
          @click="toPush"
        >{{ $t('SystemMaintenance.Publish') }}
        </el-button>
      </template>
    </div>

    <el-form
      label-width="80px"
      label-position="left"
      style="max-width: 1200px"
    >
      <el-row>
        <el-col :span="8">
          <el-form-item
            :label="$t('SystemMaintenance.AdCode')"
            class="el-form-item-search"
          >
            <el-input
              v-model="form.advertisementNo"
              :disabled="true"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <!--状态-->
          <el-form-item
            :label="$t('SystemMaintenance.Status')"
            class="el-form-item-search"
          >
            <el-select v-model="form.status" :disabled="true">
              <el-option
                v-for="item in adStatus"
                :key="item.code"
                :label="item.chineseName"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <span style="margin-right: 10px">{{ $t('SystemMaintenance.BelongingSystem') }}</span>
          <el-checkbox
            disabled
            checked="checked"
            style="margin-left: 20px;"
          > {{ 'CargoWare' }}
          </el-checkbox>
          {{ $t('SystemMaintenance.BelongsToModule') }}
          <el-checkbox
            disabled
            checked="checked"
            style="margin-left: 20px;"
          >{{ $t('SystemMaintenance.Homepage') }}
          </el-checkbox>
          {{ $t('SystemMaintenance.BelongsToPage') }}
          <el-checkbox
            disabled
            checked="checked"
            style="margin-left: 20px;"
          >{{ $t('SystemMaintenance.Homepage') }}
          </el-checkbox>
          {{ $t('SystemMaintenance.AdLocation') }}
          <el-select v-model="form.advertisingSpaceTitle" :disabled="true">
            <el-option
              v-for="item in positionList"
              :key="item.code"
              :label="item.chineseName"
              :value="item.code"
            />
          </el-select>
          <span>{{ '   支持最大广告数:' + form.pushMaxNumber }}</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item
            :label="$t('SystemMaintenance.Advertiser')"
            class="el-form-item-search"
          >
            <el-input v-show="action === 'view'" v-model="form.subjectName" :disabled="action === 'view'" />
            <cargo-advance-select
              v-show="action !== 'view'"
              :disabled="action === 'view'"
              :select-type="selectTypeNames.TENANT"
              :cache="false"
              filterable
              :custom-label="(item)=>`[${item.id}]${item.name}`"
              callback-method-type="obj"
              :default-value="form.subject||''"
              @parentCallBack="changeTenant"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$t('SystemMaintenance.SubjectName')"
            class="el-form-item-search"
          >
            <el-input
              v-model="form.title"
              :disabled="action === 'view'"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item
            :label="$t('SystemMaintenance.AdContent')"
            class="el-form-item-search"
          >
            <el-input
              v-model="form.content"
              :disabled="action === 'view'"
              style="width: 100%"
              type="textarea"
              :rows="5"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <span style="margin-right: 10px">{{ $t('SystemMaintenance.BelongingSystem') }}</span>
          <el-checkbox
            style="margin-left: 20px;"
            disabled
            checked="checked"
          > {{ $t('SystemMaintenance.Global') }}
          </el-checkbox>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item
            :label="$t('SystemMaintenance.PromotionPeriod')"
            class="el-form-item-search"
          >
            <el-date-picker
              v-model="form.cycle"
              :disabled="action === 'view'"
              value-format="yyyy-MM-dd"
              type="daterange"
              style="width: 100%"
              :picker-options="pickerOptions"
              @change="getDateList"
            />
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item>
            <date-group-slider
              v-if="form.cycle && form.cycle.length"
              v-model="form.curDate"
              :date-list="dateObject?Object.keys(dateObject):[]"
              style="margin-top: 5px"
              @change="getCurDate"
            />
            <time-group-slider v-if="dateObject" :date-object="dateObject" :time-arr="timeArr" />
          </el-form-item>
        </el-col>
        <el-col v-if="form.curDate && dateObject">
          <el-form-item :label="$t('SystemMaintenance.PromotionTimeRange')">
            <el-checkbox-group v-for="(item,index) in timeArr" :key="index" v-model="dateObject[form.curDate][index]" :disabled="action === 'view'">
              <el-checkbox v-for="time in item" :key="time" :label="time" />
              <el-button
                v-if="dateObject[form.curDate][index].length!==8"
                :disabled="action === 'view'"
                type="text"
                @click="()=>handleSelectAll(index)"
              >{{ $t('SystemMaintenance.SelectAll') }}
              </el-button>
              <el-button v-else :disabled="action === 'view'" type="text" @click="()=>handleDeSelectAll(index)">{{ $t('SystemMaintenance.DeselectAll') }}</el-button>
            </el-checkbox-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item
            :label="$t('SystemMaintenance.JumpLink')"
            class="el-form-item-search"
          >
            <el-input
              v-model="form.pageUrl"
              :disabled="action === 'view'"
              :title="form.pageUrl"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>

import DateGroupSlider from '@/views/cargo/v0/SystemMaintenance/components/Ad/DateGroupSlider'
import TimeGroupSlider from '@/views/cargo/v0/SystemMaintenance/components/Ad/TimeGroupSlider'
import { getAdvertisingSpaceForKeyFunc, queryForUuidFunc, saveAConfigFunc } from '@/api/sysManage/advertisingConfig'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { getLoading } from '@/utils/utilBaseElement'
import ColumnUtils from '@/utils/ColumnUtils'

export default {
  name: 'AdDetails',
  components: { TimeGroupSlider, DateGroupSlider, CargoAdvanceSelect },
  data() {
    return {
      action: 'view',
      loading: null,
      selectTypeNames: TYPE_NAMES,
      adStatus: SystemConstants.AD_STATUS_LIST,
      positionList: SystemConstants.AD_INDEX_LIST,
      rowList: [],
      form: {
        uuid: null,
        title: null,
        content: null,
        subject: null,
        subjectName: null,
        advertisingSpaceTitle: 'indexTop',
        advertisementNo: null,
        status: '0',
        systemSource: 'cargoWare',
        page: 'index',
        module: 'index',
        pushObject: 'all',
        pushMaxNumber: '0',
        maxNum: 0,
        cycle: [],
        advertisingSpaceConfigUuid: null,
        dateObject: {},
        advertisingSpace: {},
        curDate: null,
        pageUrl: null
      },
      pickerOptions: { // 设置可选时间范围
        disabledDate: this.disabledDate
      },
      timeArr: null,
      dateObject: {}
    }
  },
  created() {
    this.init()
  },
  methods: {
    // 设置不可选日期范围
    disabledDate(currDate) {
      const start = ColumnUtils.dateLabelFunc(currDate)
      const end = ColumnUtils.dateLabelFunc(new Date())
      return start < end
    },
    init() {
      const arr = []
      for (let i = 0; i < 6; i++) {
        arr[i] = []
        const baseHour = i * 4
        for (let j = 0; j < 4; j++) {
          const hour = baseHour + j
          arr[i].push(`${hour > 9 ? '' : 0}${hour}:00~${hour > 9 ? '' : 0}${hour}:30`)
          arr[i].push(`${hour > 9 ? '' : 0}${hour}:30~${hour + 1 > 9 ? '' : 0}${hour + 1}:00`)
        }
      }
      this.timeArr = arr
    },
    async onShow(data, action, rowList) {
      this.action = action
      this.form = data
      this.rowList = rowList
      if (action === 'add') {
        await this.setBaseData()
      }
      await this.getDateObjectFunc()
    },
    getDateObjectFunc() {
      if (this.form.promotionCycle) {
        this.dateObject = JSON.parse(this.form.promotionCycle)
      }
      if (this.dateObject) {
        // this.form.curDate = Object.keys(this.dateObject)[0]
      }
    },
    setDateObjectFunc() {
      this.form.promotionCycle = this.dateObject
    },
    toPush() {
      const updateData = {}
      updateData.status = '1'
      updateData.uuids = [this.form.uuid]
      updateData.advertisingSpaceTitle = this.form.advertisingSpaceTitle
      this.$emit('toPush', updateData)
    },
    setBaseData() {
      this.form.page = 'index'
      this.form.module = 'index'
      this.form.systemSource = 'cargoWare'
      this.form.status = '0'
      this.form.pushObject = 'all'
      this.form.advertisingSpaceTitle = 'indexTop'
    },
    toSave() {
      this.loading = getLoading()
      this.setDateObjectFunc()
      this.setBaseData()
      getAdvertisingSpaceForKeyFunc(this.form.advertisingSpaceTitle).then(res => {
        if (res.data) {
          const d = res.data
          if (d.status === '3') {
            this.$message.warning(this.$t('SystemMaintenance.ThePositionHasBeenDisabled'))
            return
          }
          this.doSave()
        }
      }).catch((err) => {
        this.$message.error(err)
        this.loading.close()
      }).finally(() => {
        this.loading.close()
      })
    },
    doSave() {
      this.loading = getLoading()
      saveAConfigFunc(this.form).then(res => {
        if (res.data) {
          if (this.action === 'add') {
            this.form.advertisementNo = res.data.advertisementNo
            this.form.uuid = res.data.uuid
            this.rowList.push(res.data)
          } else if (this.action === 'edit') {
            const index = this.rowList.findIndex(p => p.uuid === res.data.uuid)
            this.rowList[index] = res.data
          }
        }
        this.refreshHandler(this.rowList)
      }).catch((err) => {
        this.$message.error(err)
        this.loading.close()
      }).finally(() => {
        this.loading.close()
      })
    },
    refreshHandler(rowList) {
      this.action = 'view'
      this.$emit('refresh', rowList)
    },
    back() {
      this.dateObject = {}
      this.form.curDate = null
      this.$emit('back')
    },
    cancel() {
      if (this.form && this.form.uuid) {
        this.loading = getLoading()
        queryForUuidFunc(this.form.uuid).then(res => {
          if (res.data) {
            this.onShow(res.data, 'view', this.rowList)
          }
        }).catch((err) => {
          this.$message.error(err)
          this.loading.close()
        }).finally(() => {
          this.loading.close()
        })
      } else {
        this.back()
      }
    },
    toEdit() {
      this.action = 'edit'
    },
    getCurDate(data) {
      this.form.curDate = data
    },
    getDateList(e) {
      const [start, end] = e
      const dateList = [start]
      let i = 1
      while (true) {
        let dateTime = new Date(dateList[i - 1])
        dateTime = dateTime.setDate(dateTime.getDate() + 1)
        const endTime = new Date(end)
        if (dateTime > endTime) {
          break
        }
        const date = this.$moment(dateTime).format('yyyy-MM-DD')
        dateList.push(date)
        if (date === end) {
          break
        }
        i++
      }
      this.dateObject = dateList.reduce((result, item) => {
        const arr = []
        for (let i = 0; i < 6; i++) {
          arr.push([])
        }
        result[item] = arr
        return result
      }, {})
    },
    changeTenant(p) {
      this.form.subject = p.value
      this.form.subjectName = p.name
    },
    handleDeSelectAll(index) {
      if (this.form.curDate) {
        this.$set(this.dateObject[this.form.curDate], index, this.dateObject[this.form.curDate][index].splice(0, 0))
      }
    },
    handleSelectAll(index) {
      if (this.form.curDate) {
        this.timeArr[index].forEach(item => {
          if (this.dateObject[this.form.curDate][index].indexOf(item) === -1) {
            this.dateObject[this.form.curDate][index].push(item)
          }
        })
      }
    }
  }
}
</script>

<style scoped>

</style>
